var video_viewer_default = {
  "video_player": "SVOPa",
  "videoOverlay": "beDH-",
  "video_container": "zAx5h"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
